import { render, staticRenderFns } from "./HouseSize.html?vue&type=template&id=5f477b6f&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./HouseSize.scss?vue&type=style&index=0&id=5f477b6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f477b6f",
  null
  
)

export default component.exports